import React from 'react';
import { motion } from 'framer-motion';
import TopBar from '../components/TopBar';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import SEO from '../components/SEO';
import {
  contactDetails,
  galleryImages,
  successStories,
  treatmentPrinciples,
  videoHighlights,
} from '../data/siteContent';
import heroImage from '../images/slider1.jpeg';

const KillDiabetes = () => {
  return (
    <div className="kill-diabetes-page page-load-shell">
      <SEO
        title="Diabetes Treatment in Patna | Insulin and Kidney Care Guidance"
        description="Explore diabetes treatment guidance in Patna, insulin support, kidney wellness monitoring, diet counseling, and Hindi-friendly diabetes care at Uttam Diabetes Care."
        keywords="diabetes treatment Patna, insulin support Patna, kidney care Bihar, diabetes consultation Patna, sugar control doctor Bihar, Hindi diabetes treatment"
      />
      <TopBar />
      <Navbar />

      <section className="hero-section">
        <div className="hero-image">
          <img src={heroImage} alt="Diabetes care guidance" />
        </div>
        <div className="hero-overlay">
          <motion.div
            className="hero-content"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h1>Kill Diabetes</h1>
            <p>Diabetes treatment guidance, insulin support, sugar control counseling, and kidney wellness care in Patna and nearby cities</p>
          </motion.div>
        </div>
      </section>

      <section className="treatment-info">
        <div className="container">
          {treatmentPrinciples.map((section, index) => (
            <motion.div
              key={section.title}
              className="info-section"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
            >
              <span className="section-kicker">Care principle</span>
              <h2>{section.title}</h2>
              <p>{section.text}</p>
              <p className="intro-hindi">{section.hindi}</p>
              <ul>
                {section.points.map((point) => (
                  <li key={point}>{point}</li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>
      </section>

      <section className="patient-interactions">
        <div className="container">
          <span className="section-kicker">Real moments</span>
          <h2 className="section-title">Consultation & Care Highlights</h2>
          <div className="interaction-grid">
            {galleryImages.slice(0, 6).map((item, index) => (
              <motion.div
                key={`${item.alt}-${index}`}
                className="interaction-card"
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.08 }}
              >
                <img src={item.src} alt={item.alt} />
                <div className="interaction-caption">
                  <p>{item.alt}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <section className="success-stories">
        <div className="container">
          <span className="section-kicker">Patient perspective</span>
          <h2 className="section-title">What Families Commonly Appreciate</h2>
          <div className="stories-grid">
            {successStories.map((story, index) => (
              <motion.div
                key={story.title}
                className="story-card"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
              >
                <h3>{story.title}</h3>
                <p>{story.text}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <section className="video-gallery-section">
        <div className="container">
          <span className="section-kicker">Video insight</span>
          <h2 className="section-title">Treatment Journey Videos</h2>
          <div className="video-showcase-grid">
            {videoHighlights.map((video) => (
              <div key={video.id} className="video-showcase-card">
                <video className="showcase-video" controls preload="metadata" poster={video.poster}>
                  <source src={video.src} type="video/mp4" />
                </video>
                <p className="video-title">{video.title}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="cta-section">
        <div className="container">
          <motion.div
            className="cta-content"
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
          >
            <h2>Need guidance for diabetes or kidney-related concerns?</h2>
            <p>
              Call for consultation support, appointment information, and Hindi-friendly explanation of the
              next steps.
            </p>
            <a href={`tel:${contactDetails.primaryPhone.replace(/\s+/g, '')}`} className="cta-button">
              Call {contactDetails.primaryPhone}
            </a>
          </motion.div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default KillDiabetes;
